<template>
  <div>
    <v-menu offset-y transition="scroll-x-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list class="actions">
        <permission-control :permissionName="viewPermission">
          <v-list-item dense link @click="onViewClicked(item)">
            <span> <v-icon>mdi-eye</v-icon>View </span>
          </v-list-item>
        </permission-control>

        <permission-control :permissionName="editPermission">
          <v-list-item dense @click.stop="onEditClicked(item)" link>
            <span>
              <v-icon>mdi-pencil-box-outline</v-icon
              >Edit
            </span>
          </v-list-item>
        </permission-control>
        <permission-control :permissionName="softDeletePermission">
          <v-list-item link dense @click="onChangeStatusClicked(item)">
            <span>
              <v-icon>
                {{
                  item.is_active ? "mdi-archive" : "mdi-checkbox-marked-circle"
                }}
              </v-icon>
              {{ item.is_active ? "Archive" : "Active" }}
            </span>
          </v-list-item>
        </permission-control>
        <permission-control :permissionName="DeletePermission">
          <v-list-item link dense @click="onDeleteClickedItem(item)">
            <span>
              <v-icon> mdi-delete </v-icon>
              Delete
            </span>
          </v-list-item>
        </permission-control>
      </v-list>
    </v-menu>

    <v-row justify="center">
      <v-dialog v-model="dialogdelete" max-width="290">
        <v-card>
          <v-card-title class="headline">You Can Not Delete</v-card-title>
          <v-card-text
            >This data can not be delete because other data tables
            related.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="reject">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import confirmation from "../../shared/components/confirmation.vue";
import axios from "@/plugins/axios";
export default {
  data: () => ({
    dialogdelete: false,
  }),
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    feature: {
      type: String,
      default: "",
    },
    isEditModal: {
      type: Boolean,
      default: false,
    },
    isSubViewModal: {
      type: Boolean,
      default: false,
    },
    viewPermission: {
      type: String,
      default: "",
    },
    editPermission: {
      type: String,
      default: "",
    },
    softDeletePermission: {
      type: String,
      default: "",
    },
    DeletePermission: {
      type: String,
      default: "",
    },
  },
  components: {},
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    reject() {
      this.dialogdelete = false;
    },
    // onViewClicked() {
    //   this.$router.push(`/${this.feature}/${this.item.id}`);
    // },

    onViewClicked() {
      if (this.isSubViewModal) {
        this.$emit("onSubViewClicked", true);
      } else {
        this.$router.push(`/${this.feature}/${this.item.id}`);
      }
    },
    onEditClicked() {
      if (this.isEditModal) {
        this.$emit("onEditClicked", true);
      } else {
        this.$router.push(`/${this.feature}/edit/${this.item.id}`);
      }
    },
    onChangeStatusClicked(item) {
      this.$confirm(
        "Do you want to " + (item.is_active ? "Archive" : "Activate  ") + "?"
      ).then((res) => {
        if (res) {
          this.archiveOrActive(item);
        }
      });
    },
    performDelete(item) {
      this.$store
        .dispatch("common/Delete", {
          id: item.id,
          feature: this.feature,
        })
        .then(() => {
          this.$emit("refreshList", true);
          this.$toast.success("Successfully deleted " + item.name);
        })
        .catch(() => {
          this.$toast.error(item.name + " is not deleted");
        });
    },
    async onDeleteClickedItem(item) {
      this.$confirm("Do you want to Delete " + item.name + " ?").then((res) => {
        if (!res) return; // 🔥 IMPORTANT FIX — STOP when CANCEL is clicked

        let endpoint = this.feature;
        if (endpoint === "category") {
          endpoint = "categories";
        } else if (endpoint === "expenseCategory") {
          endpoint = "expense-categories";
        } else if (endpoint === "incomeCategory") {
          endpoint = "income-categories";
        } else if (endpoint === "dishes") {
          endpoint = "dishes"; // already plural
        } else if (!endpoint.endsWith("s")) {
          endpoint = `${endpoint}s`;
        }

        axios
          .get(`${endpoint}/${item.id}/check-delete-action`)
          .then((res) => {
            if (res.data.data === false) {
              this.dialogdelete = true;
            } else {
              this.performDelete(item);
            }
          })
          .catch(() => {
            // If check endpoint fails (e.g. 404), try to delete anyway
            this.performDelete(item);
          });
      });
    },

    async archiveOrActive(item) {
      await this.$store
        .dispatch("common/SoftDelete", { id: item.id, feature: this.feature })
        .then((res) => {
          this.$emit("refreshList", true);
          var msg = item.is_active ? "archived" : "activated";
          this.$toast.success("Successfully  " + msg);
        })
        .catch((err) => {});
    },
  },
  created() {},
  watch: {},
  filters: {
    hasName: function(value) {
      if (has(value, "name")) return value.name;
      else return "-";
    },
  },
};
</script>
<style>
.bg-success-light {
  background-color: rgba(15, 183, 107, 0.12) !important;
  color: #26af48 !important;
}

.appointment-action a + a {
  margin-left: 8px;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn {
  display: inline-block;
  font-weight: 700;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.2rem 0.65rem;
  font-size: 0.75rem;
  margin-right: 6px;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.bg-danger-light {
  background-color: rgba(242, 17, 54, 0.12) !important;
  color: #e63c3c !important;
}
.bg-info-light {
  background-color: rgba(2, 182, 179, 0.12) !important;
  color: #1db9aa !important;
  text-decoration: none;
}
.v-icon.v-icon {
  color: rgb(61, 133, 196);
  font-size: 15px;
}
.appointments .appointment-action {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
</style>
